import React, { Component } from 'react';
import PropTypes from 'prop-types';

const SEARCH_DEBOUNCE_MS = 300;

class BlogSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      draftSearch: props.searchText || '',
      lastAppliedSearch: props.searchText || '',
    };

    this.debounceTimer = null;

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const applied = props.searchText || '';

    if (applied !== state.lastAppliedSearch) {
      return {
        lastAppliedSearch: applied,
        draftSearch: applied,
      };
    }

    return null;
  }

  componentWillUnmount() {
    this.clearDebounce();
  }

  clearDebounce() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  submitSearch(value) {
    this.clearDebounce();
    this.props.searchSubmit(value);
  }

  handleChange(event) {
    const { value } = event.target;
    this.setState({ draftSearch: value });

    this.clearDebounce();
    this.debounceTimer = setTimeout(() => {
      this.props.searchSubmit(value);
    }, SEARCH_DEBOUNCE_MS);
  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.submitSearch(event.currentTarget.value);
      // Dismiss mobile keyboard after submit
      event.currentTarget.blur();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submitSearch(this.state.draftSearch);
    const input = event.currentTarget.querySelector('#searchInput');
    if (input) {
      // Dismiss mobile keyboard after submit
      input.blur();
    }
  }

  handleClear() {
    this.setState({ draftSearch: '' });
    this.submitSearch('');
  }

  render() {
    const hasText = this.state.draftSearch.length > 0;

    return (
      <form id="searchForm" className="blog-search-form" role="search" onSubmit={this.handleSubmit}>
        <div className="position-relative">
          <input
            className="form-control blog-search-input pe-5 rounded-1"
            type="search"
            name="searchInput"
            placeholder="Search Blogs"
            id="searchInput"
            value={this.state.draftSearch}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
          />
          {hasText ? (
            <button
              type="button"
              className="btn btn-link link-dark position-absolute top-50 end-0 translate-middle-y me-2 p-1 lh-1 z-2 d-inline-flex align-items-center"
              aria-label="Clear search"
              onClick={this.handleClear}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          ) : (
            <span className="blog-search-icon position-absolute top-50 end-0 translate-middle-y me-3 text-muted pe-none z-1" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
            </span>
          )}
        </div>
      </form>
    );
  }
}

BlogSearch.propTypes = {
  searchSubmit: PropTypes.func.isRequired,
  searchText: PropTypes.string,
};

export default BlogSearch;
